import { ref } from 'vue';
import AuthApiService, { MeResponse } from '@/services/AuthApiService';

export function useAuth() {
    const user = ref<Record<string, any> | null>(null);
    const loading = ref(false);

    /** Load the current user from the API */
    async function fetchUser() {
        loading.value = true;
        try {
            const data: MeResponse = await AuthApiService.fetchMe();
            user.value = data.user;
        } catch {
            user.value = null;
        } finally {
            loading.value = false;
        }
    }

    /** True if a user object is present */
    function isAuthenticated() {
        return !!user.value;
    }

    /** Log out locally and on the server */
    async function logout() {
        await AuthApiService.logout();
        user.value = null;
    }

    /** Kick off the external login flow */
    function login() {
        return AuthApiService.login();
    }

    return {
        user,
        loading,
        fetchUser,
        isAuthenticated,
        login,
        logout,
    };
}
